class iconNavigationBanner extends HTMLElement {
  constructor() {
    super();

    this.iconWrapper = this.querySelector('.icon-navigation-banner__inner');

    this.previousWidth = window.innerWidth;
    this.previousHeight = window.innerHeight;

    this.toggleInitSlider();
    this.handleResize();
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  handleResize() {
    const currentWidth = window.innerWidth;
    const currentHeight = window.innerHeight;
    const isHorizontalResize = currentWidth !== this.previousWidth;
    const isVerticalResize = currentHeight !== this.previousHeight;

    if (
      isHorizontalResize && !isVerticalResize
      || isHorizontalResize && isVerticalResize
    ) {
      this.toggleInitSlider();
    }

    this.previousWidth = currentWidth;
    this.previousHeight = currentHeight;
  }

  toggleInitSlider() {
    const swiper = new Swiper('.swiper', {
      loop: false,
      slidesPerView: 'auto',
      centerInsufficientSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        750: {
          spaceBwetween: 8,
        },
      },
    });
  }
}

customElements.define('icon-navigation-banner', iconNavigationBanner);
